import React from 'react';
import _ from 'lodash';

// Material UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// Components
import {
  getHundredthSeconds,
  getMinutes,
  getSeconds,
  ReviewScoreItem
} from '../../Score/ManageEvaluations/manage-evaluations.helpers';

interface IEvaluatorSkillScores {
  skillName?: string;
  roundScores: { [round: string]: IScore };
}

export const EvaluatorSkillScores: React.FC<IEvaluatorSkillScores> = ({ skillName, roundScores }) => (
  <Box>
    <Typography>{skillName}</Typography>
    <Box>
      {_.map(roundScores, (score: IScore, roundNum) => {
        if (!score) return <React.Fragment key={roundNum} />;
        const currScore = Number(score.raw);

        switch (score.type) {
          case 'TIME':
            return <ReviewScoreItem key={roundNum}><span>{getMinutes(currScore)}</span>:<span>{getSeconds(currScore)}</span>:<span>{getHundredthSeconds(currScore)}</span></ReviewScoreItem>;
          default:
            return <ReviewScoreItem key={roundNum}>{score.raw}</ReviewScoreItem>;
        }
      })}
    </Box>
  </Box>
);
